define((require) => {
    "use strict";

    var Action              = require("editor/util/Action"),
        _                   = require("underscore"),
        Preconditions       = require("shared/util/Preconditions"),
        Permissions         = require("shared/security/Permissions"),
        PublishableState    = require("util/PublishableState"),
        GroupModel          = require("shared/ui/groups/GroupModel");

    /**
     * Action that deletes a <tt>BreakpointGroup</tt> and all it experiences (assets).
     *
     * @class DeleteBreakpointGroupAction
     */
    return Action.extend("DeleteGroupAction", {

        /**
         * Constructor.
         *
         * DeleteBreakpointGroupAction
         *
         * @param  {GroupModel} group The group or group id.
         * @param  {Object} [options] Optional options (such as project context).
         */
        constructor: function(group, options) {
            this.__super();

            Preconditions.instanceOf(group, GroupModel, "A valid group instance must be specified.");

            this._group = group;

            this._options = options || {};
        },

        executable: function() {
            if (!this._group || Permissions.Privileges.CREATE.cannot()) {
                return false;
            }

            // If you cannot publish, you may only delete un-pushed data...
            if (Permissions.Privileges.PUBLISH.cannot()) {
                var experiences = this._group.getAssets();

                return !this._group.hasAtLeastState(PublishableState.PUSHED) && !_.some(experiences, (experience) => {
                    return experience.hasAtLeastState(PublishableState.PUSHED);
                });
            }

            return true;
        },

        _performExecution: function() {
            return this._group.destroyWithAssets();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/actions/DeleteGroupAction.js